import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// Components
import GoldCardContent from './GoldCardContent';
import PlatinumCardContent from './PlatinumCardContent';
import DeltaReserveCardContent from './DeltaReserveCardContent';
import OfferBoxWithCtas from '../../OfferBoxWithCtas';
import ScrollDownButton from './ScrollDownButton';
import BackgroundImage from './BackgroundImage';

// selectors and utils
import {
  shouldShowDynamicAppPDP,
  havingDualOffer
} from 'page_modules/business-pdp/redux';
import { getOverlayOpacity, getOverlayColor } from '../redux';
import { isG170DesktopVariant } from 'src/universal/components/Experiments/G170/redux';
import { hasPznDataArrived } from 'src/universal/redux/pznData';
import { getWinHeight, getWinWidth } from 'src/universal/utils/clientSideDetection';

// styles
import styles from '../__styles__/hero.scss?modules';
import heroOfferBoxStyles from '../../OfferBoxWithCtas/__styles__/index.scss?modules';

const Hero = ({
  onClick,
  shortName,
  hasDynamicAppBox,
  overlayOpacity,
  overlayColor,
  isNonPremiumCard = false,
  hasDualOffer,
  isG170Desktop,
  pznArrived
}) => {
  const heroRef = useRef();

  useEffect(
    () => {
      /*
    US5719496: the next block prevents the OfferBox content being permanently cut off
    for the users that have very short screen height (less than 768px)
    */
      const winHeight = getWinHeight();
      const winWidth = getWinWidth();

      if (pznArrived && winWidth > 767 && winHeight < 768) {
        setTimeout(() => {
          const eleWrapSel = 'div[class*="purify_hero__container--"]';
          const eleSel = `${eleWrapSel} [class*="purify_hero__contentAndOfferContainer--"] [class*="purify_index__container--"]`;
          const eleTarget = document.querySelector(eleSel);

          if (!eleTarget || typeof eleTarget.getBoundingClientRect !== 'function') {
            return;
          }

          const eleRect = eleTarget.getBoundingClientRect();
          const offsetVal = 120 + (isG170Desktop ? 110 : 0); // 120 = iNav + subNav.  110 = filmStrip height
          const eleVPos = eleRect.bottom + 70; // 70 = the height of the scroll-down link
          const targetH = eleVPos - offsetVal;

          if (eleVPos > winHeight && heroRef.current) {
            heroRef.current.style.minHeight = `${targetH}px`;

            if (shortName === 'platinum') {
              const eleImg = document.querySelector(
                `${eleWrapSel} [class*="purify_backImgNew__picture--"] img`
              );

              if (eleImg) {
                eleImg.style.left = `calc((100% - ((1024 * ${targetH}px) / 723)) / 3.5)`;
              }
            }
          }
        }, 200);
      }
    },
    [pznArrived]
  );

  return (
    <div
      ref={heroRef}
      className={clsx(styles.container, styles[shortName], {
        [styles.hasDynamicAppBox]: hasDynamicAppBox,
        [styles.backgroundColor]: isNonPremiumCard,
        [styles.hasDualOffer]: hasDualOffer,
        [styles.isG170Desktop]: isG170Desktop
      })}
    >
      <div
        style={{ opacity: overlayOpacity, background: overlayColor }}
        className={styles.overlay}
      />
      {!isNonPremiumCard && <BackgroundImage />}
      <div className={styles.contentContainer}>
        <div className={clsx(styles.contentAndOfferContainer)}>
          <GoldCardContent />
          <PlatinumCardContent />
          <DeltaReserveCardContent />
          <OfferBoxWithCtas shortName={shortName} styles={heroOfferBoxStyles} />
        </div>
        <ScrollDownButton onClick={onClick} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    hasDynamicAppBox: shouldShowDynamicAppPDP(state),
    overlayOpacity: getOverlayOpacity(state),
    overlayColor: getOverlayColor(state),
    hasDualOffer: havingDualOffer(state),
    isG170Desktop: isG170DesktopVariant(state),
    pznArrived: hasPznDataArrived(state)
  };
};

export default connect(mapStateToProps)(React.memo(Hero));
